import Swal from "sweetalert2";
import Draggable from 'react-draggable';
import Modal from '@mui/material/Modal';
import { Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { IconButton } from '@mui/material';
import StacInterface from "utils/StacInterface";
import React, { useState, useEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import withReactContent from "sweetalert2-react-content";
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '50%',
        height: '50%',
        top: `25%`,
        left: `25%`,
        transform: `translate(-50%, -50%)`,
        color: 'black',
        backgroundColor: 'white',
        border: '1px solid #000',
        borderRadius: '5px',
        '@media (max-width: 900px)': {
            width: '80%',
            left: '10%',
        },
        '@media (max-width: 500px)': {
            width: '90%',
            left: '5%',
        },
    },
}));

const APIUsages = () => {
    const classes = useStyles();
    const [showModal, setShowModal] = useState(false);
    const [displayChart, setDisplayChart] = useState();
    const [selectedService, setSelectedService] = useState();
    const [userServiceData, setUserServiceData] = useState([]);
    const [serviceChartData, setServiceChartData] = useState();

    const handleModalClose = () => {
        displayChart.dispose();
        setShowModal(false);
        setSelectedService();
    };

    const createChart = (data) => {
        const timer = setTimeout(() => {
            const chartContainer = document.getElementById("service-chart");
            if (chartContainer) {
                am4core.disposeAllCharts();
                let chart = am4core.create("service-chart", am4charts.XYChart);
                setDisplayChart(chart);
                chart.data = data;
                chart.paddingLeft = 20;
                chart.paddingRight = 40;
                chart.background.fill = am4core.color("#f7f8fa");

                let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "Day";
                categoryAxis.cursorTooltipEnabled = false;
                categoryAxis.renderer.minGridDistance = 40;
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.labels.template.rotation = -65;
                categoryAxis.renderer.labels.template.verticalCenter = "middle";
                categoryAxis.renderer.labels.template.horizontalCenter = "right";
                categoryAxis.renderer.labels.template.fill = am4core.color("#2348a2");

                let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.cursorTooltipEnabled = false;
                valueAxis.renderer.labels.template.fill = am4core.color("#2348a2");

                let series = chart.series.push(new am4charts.ColumnSeries());
                series.name = "# Request";
                series.dataFields.categoryX = "Day";
                series.dataFields.valueY = "# Request";
                series.columns.template.strokeOpacity = 0;
                series.tooltip.getFillFromObject = false;
                series.columns.template.width = am4core.percent(70);
                series.columns.template.tooltipText = "[bold #487af2]{categoryX}[/]\n[ #487af2] No. of Requests: {valueY}[/]";
                
                let columnTemplate = series.columns.template;
                columnTemplate.fill = am4core.color("#487af2");
                columnTemplate.events.off("adapter", undefined, undefined);
        
                chart.logo.disabled = true;
                chart.cursor = new am4charts.XYCursor();
                chart.cursor.lineX.stroke = am4core.color("#234085");
                chart.cursor.lineX.strokeOpacity = 0.6;
                chart.cursor.lineY.strokeOpacity = 0;
                chart.appear(500, 80);
            }
        }, 100);

        return () => clearTimeout(timer);
    }

    useEffect(() => {
        StacInterface.instance.getUserServiceUsages().then(response => {
            setUserServiceData(response.data);
        });
    }, [])

    useEffect(() => {
        if (selectedService === null || selectedService === undefined) return;

        StacInterface.instance.getUserServiceUsageDetails(selectedService).then(response => {
            let dailyData = getDailySum(response.data);
            let data = dailyData.map((detail) => {
                return { 'Day': detail[0], '# Request': detail[1] }
            });
            setServiceChartData(data);
            setShowModal(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        })
    }, [selectedService])

    useEffect(() => {
        if (serviceChartData === null || serviceChartData === undefined || !showModal) return;

        createChart(serviceChartData)
    }, [serviceChartData, showModal])

    const getDailySum = (data) => {
        const groups = data.reduce((map, el) => {
            const dateKey = new Date(`${el.to_datetime}z`).toLocaleDateString('en')
            map.set(dateKey, map.get(dateKey) ? map.get(dateKey) + el.count : el.count);
            return map;
        }, new Map());
        return Array.from(groups.entries());
    }

    const viewUsageDetail = (service) => {
        setSelectedService(service);
    }

    const CustomTooltip = (props) => {
        const useStyles = makeStyles((theme) => ({
            tooltip: {
                color: "white",
                fontSize: "12px !important",
                backgroundColor: "#5A5A5A",
                borderRadius: 3,
                fontFamily: 'Roboto',
                padding: '8px 10px'
            }
        }));
        const classes = useStyles();
        return <Tooltip classes={classes} {...props} />;
    }

    return (<>
        <div style={{ fontSize: 21, marginBottom: 15 }}>API Usages</div>
        <table style={{ width: '100%' }}>
            <tr style={{ fontSize: 11, fontWeight: "bold", borderTop: 'white solid 1px', borderBottom: 'white solid 1px', height: 45 }}>
                <td>ENDPOINT</td>
                <td># OF REQUESTS</td>
                <td>LAST REQUEST</td>
                <td>DETAIL</td>
            </tr>
            {userServiceData.map(serviceUsage => {
                return (
                    <tr key={serviceUsage.service} style={{ borderTop: 'white solid 1px', borderBottom: 'white solid 1px', height: 45 }}>
                        <td>{serviceUsage.service}</td>
                        <td>{serviceUsage.count}</td>
                        <td>{new Date(`${serviceUsage.latest_request_datetime}z`).toLocaleString({ year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric' })}</td>
                        <td><CustomTooltip title="View Details" placement="right"><IconButton onClick={() => viewUsageDetail(serviceUsage.service)} color='inherit'><AssessmentOutlinedIcon fontSize='large'/></IconButton></CustomTooltip></td>
                    </tr>
                )
            })}
        </table>
        <Modal open={showModal} onClose={handleModalClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
            <div>
                <Draggable handle="h2">
                    <div className={classes.paper}>
                        <h2 id="simple-modal-title" style={{padding: '20px'}}>Daily Usage for {selectedService} Service</h2>
                        <div id="service-chart" style={{ height: 'calc(100% - 20px)' }} />
                    </div>
                </Draggable>
            </div>
        </Modal>
    </>)
}

export default APIUsages;